import React, { useState } from 'react';
import Confetti from 'react-confetti';

import AndModal from '../Common/AndModal';
import ConnectModalDialog from './ConnectModalDialog';
import { BasicProfile, getMeta } from '../../utils/qr';

import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';

export interface ConnectUsingQRProps {
  basicProfile: BasicProfile;
  queryParams: URLSearchParams;
}

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export default function WarmConnect({
  basicProfile,
  queryParams,
}: ConnectUsingQRProps) {
  const [open, setOpen] = useState(false);
  const [didOpenGift, setDidOpenGift] = useState(false);
  const meta = getMeta(basicProfile, queryParams);
  const firstName = queryParams.get('fn');

  if (!meta) {
    return null;
  }
  const isInvite = meta.action === 'iv';

  function handleOpenGiftClick() {
    setDidOpenGift(true);
  }

  if (isInvite && !didOpenGift) {
    return (
      <Stack
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: { sm: 'top', md: 'center' },
          alignItems: 'center',
          textAlign: 'center',
          height: '100vh',
        }}
        onClick={handleOpenGiftClick}
      >
        <Box sx={{ pb: { xs: 5, md: 0 } }}>
          <FontAwesomeIcon
            icon={faGift}
            bounce
            fontSize={'20rem'}
            color="var(--and-palette-secondary-500)"
          />
        </Box>
        <Typography level="h2">
          {firstName || 'Someone'} sent you a gift.
        </Typography>
        <Typography level="body2">Click anywhere to open</Typography>
      </Stack>
    );
  }

  return (
    <Stack
      spacing={-1}
      sx={{
        display: 'flex',
        justifyContent: 'top',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      {isInvite && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={500}
          recycle={false}
        />
      )}
      <Box sx={{ height: '50%' }}>
        <img src={meta.image} alt="yay!" />
      </Box>
      <Typography level="h1" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
        {meta.title}
      </Typography>
      <Typography sx={{ color: '#333333' }}>{meta.detail}</Typography>
      <Box sx={{ pt: 5 }}>
        {!isIOS ? (
          <Button
            size="lg"
            sx={{
              fontWeight: 500,
              borderRadius: 10,
              backgroundColor: 'var(--and-palette-secondary-500)',
            }}
            onClick={() => setOpen(true)}
          >
            {meta.buttonTitle}
          </Button>
        ) : (
          <Typography level="body2">Tap the banner above</Typography>
        )}
        <AndModal open={open} onClose={() => setOpen(false)} modalMode="center">
          <ConnectModalDialog
            basicProfile={basicProfile}
            queryParams={queryParams}
            actionOverride="cl"
          />
        </AndModal>
      </Box>
    </Stack>
  );
}
